import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { PAGE_CONTAINER_WIDTH } from "../../../constants/genericSizes";

export const MobileNavigationBar = styled.nav`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: ${PAGE_CONTAINER_WIDTH.NORMAL};
  display: flex;
  justify-content: space-around;
  z-index: 100;
  padding: 1rem;
`;

export const MobileNavItem = styled(Link)<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #ffffff;
  transition:
    transform 0.12s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
  box-sizing: border-box;
  min-width: 0;
  flex-shrink: 1;
  width: 100%;
  height: 3rem;
  border-radius: 6.25rem;
  position: relative;

  ${({ isActive }) =>
    isActive
      ? `
    background: #ffffff;
  `
      : `
    background: transparent;
  `};

  svg {
    flex-shrink: 0;
  }
`;
